<template>
  <div>
    <b-button
      variant="secondary"
      @click="showNewRowModal = !showNewRowModal"
    >
      Add Row
    </b-button>

    <b-modal
      v-model="showNewRowModal"
      size="lg"
      title="Add New Row"
      scrollable
      ok-title="Submit"
      @ok="handleSubmit"
      @hidden="onHideModal"
      @show="onModalShow"
    >
      <div
        v-for="(field, index) in fields"
        :key="index"
      >
        <b-form-group
          v-if="field.type === 'textarea' || field.type === 'alpha' && field.displayInForm"
          :label="field.label"
        >
          <b-form-textarea
            v-model.trim="row[field.name]"
            :state="validate(field)"
          />
        </b-form-group>

        <b-form-group
          v-else-if="field.type === 'dropdown' && field.displayInForm"
          :label="field.label"
        >
          <b-input
            v-for="(option, index) in row[field.name]"
            :key="index"
            v-model.trim="option.value"
            type="text"
            class="mb-3"
            :state="validate(field)"
          />
          <b-button
            class="mt-4"
            @click="addOption(field.name)"
          >
            Add Option
          </b-button>
        </b-form-group>

        <b-form-group v-else-if="field.type === 'checkbox' && field.displayInForm">
          <b-form-checkbox
            v-model="row[field.name]"
            value="true"
            unchecked-value="false"
          >
            {{ field.label }}
          </b-form-checkbox>
        </b-form-group>

        <b-form-group
          v-else-if="field.displayInForm"
          :label="field.label"
        >
          <b-input
            v-model.trim="row[field.name]"
            :type="field.type"
            :state="validate(field)"
          />
        </b-form-group>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {createNamespacedHelpers} from 'vuex';

const {mapState, mapActions} = createNamespacedHelpers('dataManagement');

export default {
  name: 'AddNewRow',
  components: {},
  data() {
    return {
      showNewRowModal: false,
    };
  },
  computed: {
    ...mapState({
      schema: state => state.table.schema,
      fields: state => state.table.schema.fields,
      row: state => state.table.row,
    }),
  },
  methods: {
    ...mapActions(['getTable', 'addNewRow', 'setTableRow']),
    validate(field) {
      if (field.required) {
        if (field.type === 'text' || field.type === 'textarea' || field.type === 'alpha' || field.type === 'email' || field.type === 'date') {
          if (this.row[field.name] !== null) {
            if (typeof (this.row[field.name]) === 'string') {
              return (this.row[field.name].length > 0) ? this.checkMinMax(field) : false;
            }
          } else {
            return false;
          }
        }
        if (field.type === 'number') {
          return (this.row[field.name] !== null) ? this.checkMinMax(field) : false;
        }
        if (field.type === 'dropdown') {
          let state = false;
          this.row[field.name].forEach(obj => {
            if (obj.value.length > 0) {
              state = true;
            }
          });
          return state;
        }
      }
      return this.checkMinMax(field);
    },
    checkMinMax(field) {
      if (field.type === 'text' || field.type === 'textarea' || field.type === 'alpha' || field.type === 'email' || field.type === 'date') {
        if (typeof (this.row[field.name]) === 'string' && this.row[field.name].length >= 1) {
          return (field.min && !field.max) ? this.row[field.name].length >= field.min :
            (!field.min && field.max) ? this.row[field.name].length <= field.max :
              (field.min && field.max) ? this.row[field.name].length >= field.min && this.row[field.name].length <= field.max : true;
        }
        return true;
      }
      if (field.type === 'number' && !isNaN(parseInt(this.row[field.name]))) {
        return (field.min && !field.max) ? parseInt(this.row[field.name]) >= field.min :
          (!field.min && field.max) ? parseInt(this.row[field.name]) <= field.max :
            (field.min && field.max) ? parseInt(this.row[field.name]) >= field.min && parseInt(this.row[field.name]) <= field.max : true;
      }
      return true;
    },
    onModalShow() {
      this.setTableRow(this.$route.params.tableId);
    },
    onHideModal() {
      this.setTableRow(this.$route.params.tableId);
    },
    addOption(fieldName) {
      this.row[fieldName] = [...this.row[fieldName], {value: ''}];
    },
    handleSubmit() {
      this.addNewRow(this.row);
      this.setTableRow(this.$route.params.tableId);
    },
  },
};
</script>
<style lang="scss" scoped>


</style>
